<template>
<v-container fluid>
    <my-group-head/>
    <v-btn to='/'>home</v-btn>
</v-container>
</template>

<script>
export default {
components: {
    'my-group-head': () => import ('@/components/GroupHead'),
    
    
  },
}
</script>

<style>

</style>